import NativeFlex from 'components/NativePost/Bits/NativeFlex';
import NativeIcon from 'components/NativePost/Bits/NativeIcon';
import styled from 'components/_UI/designSystem';

export const StyledNativeEngagement = styled(NativeFlex)`
    color: #777;
    font-size: 0.85em;
    ${NativeIcon} {
        svg {
            fill: #777;
        }
    }
`;
